import { render, staticRenderFns } from "./DeviceNameplateEdit.vue?vue&type=template&id=8af32132&scoped=true"
import script from "./DeviceNameplateEdit.vue?vue&type=script&lang=js"
export * from "./DeviceNameplateEdit.vue?vue&type=script&lang=js"
import style0 from "./DeviceNameplateEdit.vue?vue&type=style&index=0&id=8af32132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af32132",
  null
  
)

export default component.exports